<template>
  <div class="page">
    <!-- 美化版页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">平台用戶列表</h1>
      </div>
      <div class="header-right">
        <el-button size="mini" type="warning" @click.native="onAdd" class="btn-add">新增用戶帳號</el-button>
        <el-button size="mini" type="default" @click="onDownload" icon="el-icon-download">下載</el-button>
        <importExcelUser @importExcel="importExcel" class="import-btn"></importExcelUser>
<!--        <el-button size="mini" type="warning" @click.native="onDerive" class="btn-add">批量導入家長和學生</el-button>-->
      </div>
    </div>

    <div class="layout">
      <!-- 美化版搜索区 -->
      <div class="search-card">
        <div class="search-row">
          <el-input
              v-model="listQuery.emailLike"
              placeholder="搜尋電郵地址"
              prefix-icon="el-icon-search"
              size="small"
          ></el-input>
          <el-input
              v-model="listQuery.nameLike"
              placeholder="搜尋用戶姓名"
              prefix-icon="el-icon-user"
              size="small"
          ></el-input>
          <el-input
              v-model="listQuery.phoneLike"
              placeholder="搜尋聯繫方式"
              prefix-icon="el-icon-phone"
              size="small"
          ></el-input>
          <div class="search-buttons">
            <el-button size="small" type="warning" @click.native="onSearch" icon="el-icon-search">搜尋</el-button>
            <el-button size="small" @click="onReset" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
      </div>

      <!-- PC端表格 + 手机端卡片列表 -->
      <div class="table-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              @sort-change="handleSortChange"
              :data="tableData"
              style="width:100%"
              border
              stripe
              size="small"
          >
            <el-table-column prop="email" label="電郵地址" align="center" sortable="custom" min-width="200"></el-table-column>
            <el-table-column prop="name" label="用户姓名" align="center" sortable="custom" min-width="120"></el-table-column>
            <el-table-column prop="status" label="帳號狀態" align="center" sortable="custom" width="100">
              <template slot-scope="{ row }">
                <el-tag :type="row.status === 1 ? 'success' : 'danger'">
                  {{ row.status | studentCodeStatus }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="電話" align="center" sortable="custom" min-width="120"></el-table-column>
            <el-table-column prop="createdAt" label="創建時間" align="center" sortable="custom" min-width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.createdAt | formatDateTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="onEditorButton(scope.row.id)" icon="el-icon-edit">編輯</el-button>
                <el-button type="text" size="small" @click="onDetailButton(scope.row.id)" icon="el-icon-view">詳情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片列表（<768px显示） -->
        <div class="mobile-cards">
          <div class="user-card" v-for="item in tableData" :key="item.id">
            <div class="card-header">
              <div class="user-name">{{ item.name }}</div>
              <el-tag :type="item.status === 1 ? 'success' : 'danger'" size="mini">
                {{ item.status | studentCodeStatus }}
              </el-tag>
            </div>
            <div class="card-body">
              <div class="info-item">
                <span class="info-label">電郵地址：</span>
                <span class="info-value">{{ item.email }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">電話：</span>
                <span class="info-value">{{ item.phone || '未填寫' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">創建時間：</span>
                <span class="info-value">{{ item.createdAt | formatDateTime }}</span>
              </div>
            </div>
            <div class="card-footer">
              <el-button size="mini" type="warning" @click="onEditorButton(item.id)" icon="el-icon-edit">編輯</el-button>
              <el-button size="mini" type="default" @click="onDetailButton(item.id)" icon="el-icon-view">詳情</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 美化版分页 -->
    <div class="pagination-wrap">
      <Pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery._page"
          :limit.sync="listQuery._limit"
          @pagination="getUsers"
      />
    </div>
  </div>
</template>

<script>
import { getUserReport } from "@/api/report";
import { getUsers } from "@/api/users";
import Pagination from "@/components/Pagination";
import { downloadFile } from "@/utils/is-rules";
import importExcelUser from "./components/importExcelUser";
export default {
  components: { Pagination,importExcelUser },
  filters: {
    studentCodeStatus(v) {
      return v === 0 ? "封鎖" : "生效";
    },
    formatDateTime(time) {
      if (!time) return "";
      const d = new Date(time);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
    }
  },
  data() {
    return {
      total: 0,
      listQuery: {
        type: 0,
        userNoLike: null,
        nameLike: null,
        emailLike: null,
        phoneLike: null,
        gender: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      tableData: [],
    };
  },
  created() {
    this.getUsers();
  },
  methods: {
    // Excel导入回调
    importExcel() {
      this.$message.success("Excel導入成功");
      this.getUsers();
    },
    onDownload() {
      this.getUserReport();
    },
    getUserReport() {
      const params = {
        nameLike: this.listQuery.nameLike,
        emailLike: this.listQuery.emailLike,
        phoneLike: this.listQuery.phoneLike,
      };
      getUserReport(params).then(res => {
        downloadFile(res.data, "userReport.xlsx");
      });
    },
    handleSortChange(col) {
      this.listQuery.orderBy = col.order ? `${col.prop} ${col.order === "descending" ? "desc" : "asc"}` : null;
      this.listQuery._page = 1;
      this.getUsers();
    },
    onSearch() {
      this.listQuery._page = 1;
      this.getUsers();
    },
    onReset() {
      Object.keys(this.listQuery).forEach(k => {
        this.listQuery[k] = null;
        if (k === "_page") this.listQuery[k] = 1;
        if (k === "_limit") this.listQuery[k] = 10;
      });
      this.getUsers();
    },
    onEditorButton(id) {
      this.$router.push(`/user/${id}/edit`);
    },
    onAdd() {
      this.$router.push("/user/add");
    },
    onDetailButton(id) {
      this.$router.push(`/user/${id}`);
    },
    getUsers() {
      const params = {
        ...this.listQuery,
        type: 1,
        _page: this.listQuery._page - 1,
      };
      getUsers(params).then(v => {
        this.tableData = v.data;
        this.total = +v.headers["x-total-count"];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 美化版页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 20px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0 0 4px 0;
    }
    .page-desc {
      font-size: 12px;
      color: #666;
      margin: 0;
    }
  }

  .header-right {
    .el-button {
      padding: 8px 16px;
    }
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  //padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  //margin-bottom: 16px;
}

/* 美化版搜索卡片 */
.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;

    .el-input {
      flex: 1;
      min-width: 180px;
    }

    .search-buttons {
      display: flex;
      gap: 8px;
    }
  }
}

/* 表格/卡片容器 */
.table-container {
  width: 100%;

  /* PC端表格样式 */
  .pc-table {
    ::v-deep .el-table {
      --el-table-header-text-color: #4e5969;
      --el-table-row-hover-bg-color: #f8f9fa;
    }

    ::v-deep .el-table th {
      background: #f8f9fa;
      font-weight: 600;
    }
  }

  /* 手机端卡片列表样式 */
  .mobile-cards {
    display: none;
    gap: 12px;

    .user-card {
      background: #fff;
      border: 1px solid #e9ecef;
      border-radius: 8px;
      padding: 16px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;

        .user-name {
          font-size: 16px;
          font-weight: 600;
          color: #1f2937;
        }
      }

      .card-body {
        margin-bottom: 16px;

        .info-item {
          display: flex;
          margin-bottom: 8px;
          line-height: 1.5;

          .info-label {
            color: #6c757d;
            width: 80px;
            flex-shrink: 0;
          }

          .info-value {
            color: #1f2937;
            flex: 1;
            word-break: break-all;
          }
        }
      }

      .card-footer {
        display: flex;
        gap: 8px;
        justify-content: flex-end;
      }
    }
  }
}

/* 分页样式 */
.pagination-wrap {
  text-align: center;
  ::v-deep .el-pagination {
    --el-pagination-button-bg-color: #fff;
    --el-pagination-button-hover-bg-color: #f8f9fa;
    --el-pagination-button-active-bg-color: #409eff;
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    padding: 12px 16px;
    flex-direction: column;
    align-items: flex-start;
  }

  .layout {
    padding: 12px;
  }

  .search-card .search-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  /* 隐藏PC表格，显示手机卡片 */
  .table-container .pc-table {
    display: none;
  }
  .table-container .mobile-cards {
    display: flex;
    flex-direction: column;
  }
}

</style>